import { Component, OnInit, ViewChild } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IUser } from '@app/core/interfaces/user/IUser';
import { UserService } from '@app/core/services/UserService';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';
import { MunicipalityService } from '@app/core/services/municipalityService';
import { MessagesDialogComponent } from '../../shared/messages/messages-dialog-component';
import { environment as env } from '@env/environment';
import { OrganizationService } from '@app/core/services/OrganizationService';
import { AuthenticationService } from '@app/core/services/AuthenticationService';

@Component({
  standalone: false,
  selector: 'AccountBalance',
  templateUrl: './accountBalance.component.html',
  styleUrls: ['./accountBalance.component.scss']
})

export class AccountBalanceComponent implements OnInit {

  currentUserId: string;
  transactionLogs: any;
  transactionLogs2: any;
  transactionLogs3: any;
  displayedColumns = ['status', 'amount', 'due'];
  displayedColumns2 = ['Month', 'NetSalarySum', 'PensionSum', 'AttachmentSum'];
  expandedElement: any | null = null;
  displayedColumns3 = ['Year', 'NetSalarySum', 'PensionSum', 'AttachmentSum'];

  public isLoading: boolean = true;
  private pendingRequests = 3;
  currentYear: number;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  dataSource2: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  dataSource3: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  constructor(
    private localStorageService: LocalStorageService,
    private loadingService: LoadingBarService,
    private userService: UserService,
    private municipalityService: MunicipalityService,
    private router: Router,
    private organizationService: OrganizationService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog
  ) { }
    
  ngOnInit() {
    this.currentYear = new Date().getFullYear();

    this.currentUserId = this.authenticationService.userData.UserId;
    this.loadingService.start();
    this.getTranslogsFuturePayouts();
    this.getCurrentYearTranslogs();
    this.GetAllTranslogs();
  }

  getSwedishMonthName(month: number): string {
    const date = new Date(2000, month - 1); // Januari = 0
    return date.toLocaleString('sv-SE', { month: 'long' }).charAt(0).toUpperCase() +
      date.toLocaleString('sv-SE', { month: 'long' }).slice(1);
  }

  getTranslogsFuturePayouts() {

    this.userService.getUserFuturePayoutTranslogs(this.currentUserId)
      .subscribe(
        response => this.translogsLoaded(response),
        error => this.loadFailed(error)
      );
  }

  getCurrentYearTranslogs() {

    this.userService.getUserCurrentYearTranslogs(this.currentUserId)
      .subscribe(
        response => this.translogsCurrentYearLoaded(response),
        error => this.loadFailed(error)
      );
  }

  GetAllTranslogs() {

    this.userService.getUserCurrentAllTranslogs(this.currentUserId)
      .subscribe(
        response => this.translogsAllLoaded(response),
        error => this.loadFailed(error)
      );
  }

  get totalNetSalaryToRecieve(): number {
    return (this.dataSource?.data || []).reduce((sum, row) => sum + (row.NetSalary || 0), 0);
  }

  // Current year
  get totalNetSalary(): number {
    return (this.dataSource2?.data || []).reduce((sum, row) => sum + (row.NetSalarySum || 0), 0);
  }

  get totalPension(): number {
    return (this.dataSource2?.data || []).reduce((sum, row) => sum + (row.PensionSum || 0), 0);
  }

  get totalAttachment(): number {
    return (this.dataSource2?.data || []).reduce((sum, row) => sum + (row.AttachmentSum || 0), 0);
  }

  // All years
  get totalNetSalary3(): number {
    return (this.dataSource3?.data || []).reduce((sum, row) => sum + (row.NetSalarySum || 0), 0) || 0;
  }

  get totalPension3(): number {
    return (this.dataSource3?.data || []).reduce((sum, row) => sum + (row.PensionSum || 0), 0) || 0;
  }

  get totalAttachment3(): number {
    return (this.dataSource3?.data || []).reduce((sum, row) => sum + (row.AttachmentSum || 0), 0) || 0;
  }

  translogsLoaded(response: any[]): void {
    this.transactionLogs = response || [];

    console.log(this.transactionLogs);

    this.dataSource.data = this.transactionLogs;
    this.table?.renderRows();
    this.completeRequest();
  }

  translogsCurrentYearLoaded(response: any[]): void {
    this.transactionLogs2 = response || [];
    this.dataSource2.data = this.transactionLogs2;
    this.completeRequest();
    //this.table.renderRows();
  }

  translogsAllLoaded(response: any[]): void {

    this.transactionLogs3 = response || [];
    this.dataSource3.data = this.transactionLogs3;
    this.completeRequest();
    //this.table.renderRows();
  }

  private loadFailed(error: any): void {
    console.log(error);
    this.completeRequest();
  }

  private completeRequest(): void {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    if (this.pendingRequests === 0) {
      Promise.resolve().then(() => {
        this.isLoading = false;
        this.loadingService.complete();
      });
    }
  }

}



